import { Box } from '@material-ui/core';
import Logo from './Logo';

const SplashPage = () => (
  <Box
    sx={{
      alignItems: 'center',
      backgroundColor: 'background.paper',
      display: 'flex',
      flexDirection: 'column',
      height: '100%',
      justifyContent: 'center',
      p: 3,
      position: 'relative',
      width: '100%',
    }}
  >
    <Logo />
  </Box>
);

export default SplashPage;
